<template>
  <div class="main__wrapper">
    <el-container>
      <el-main :style="cssProps">
        <el-form>
          <template v-for="(eachFormObj, eachFormIndex) in forms">
            <el-divider :key="`divider-${eachFormIndex}`">{{ eachFormObj.title }}</el-divider>
            <el-row :key="`row-${eachFormIndex}`">
              <div class="wrapper--forms">
                <el-col
                  v-for="(field, index) in eachFormObj.fields"
                  :key="index"
                  :span="field.span"
                  v-bind="field"
                  class="form__group  sm-12 xs-12"
                >
                  <!-- <label class="form__label" v-model="form.label" v-show="form.hasOwnProperty('label')">{{ form.label }}</label> -->
                  <component  :is="field.fieldType" :currentField="field" class="form__field" :style="field.componentValue == null ? {border:'solid 1px red',padding:'7px'} 
                              : field.componentValue == '0' && {border:'solid 1px red',padding:'7px'}"></component>
                  <!-- <small class="form__helpblock" v-model="form.helpBlockText" v-show="form.isHelpBlockVisible">
                  {{ form.helpBlockText }}
                </small> -->
                <!-- <h1> {{ filePath }} </h1> -->
                </el-col>
              </div>
            </el-row>
          </template>
          <!-- <div>
             <img src="" alt="" hidden>
          </div> -->
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { FormBuilder } from './form_elements/formbuilder';
import { axiosGet } from '../../../Helpers/AxiosHelper';
import { FORM_BUILDER_GET, FORM_BUILDER_RESPONSE_GET } from '../../../Config/ApiUrl';

export default {
  name: 'Publish',
  // store: ['forms', 'themingVars'],
  data() {
    return {
      // forms: this.$store.state.formBuilder.forms,
      forms: [],
      response: [],
      themingVars: this.$store.state.formBuilder.themingVars,
      formFields: ['this']
    };
  },
  components: FormBuilder.$options.components,
  methods: {
    async getFormResponseData() {
      axiosGet(FORM_BUILDER_RESPONSE_GET)
        .then((res) => {
          this.forms = res.data.body;
        })
        .catch((res) => {
          console.error(res);
        });
    },
  },
  created() {
    this.getFormResponseData();
  },
  mounted() {
    this.$store.state.inputMode.type = false;
  },
  computed: {
    cssProps() {
      // Return an object that will generate css properties key
      // to match with the themingVars
      //
      // Example output: { '--theme-primary-color': this.themingVars.primaryColor }
      var result = {},
        themingVars = this.themingVars;

      for (var v in themingVars) {
        if (themingVars.hasOwnProperty(v)) {
          var newV = '--theme-' + _.kebabCase(v),
            suffix = '';

          // Add px to the value if the default value contain 'px'
          if (_.includes(newV, 'size')) suffix = 'px';
          else if (_.includes(newV, 'margin')) suffix = 'px';
          else if (_.includes(newV, 'radius')) suffix = 'px';

          result[newV] = themingVars[v] + suffix;
        }
      }

      return result;
    },
    // filePath(){
    //   return this.$store.state.uploadFilePath.dataUploadFilePath ;
    // }
  }
};
</script>
